import React from "react";
import { Clock } from 'lucide-react';

function ExamplePageOne() {
  return (
    <div className="p-4 bg-white rounded-b-xl w-full min-h-full flex flex-col">

      {/* Header */}
      <div className="text-center mb-4">
        <h3 className="text-sm font-black text-gray-900 tracking-tight">Your Deep Analysis</h3>
        <p className="text-[10px] text-gray-400 mt-0.5">Based on your conversation history</p>
      </div>

      {/* Analysis quote */}
      <div className="bg-gradient-to-br from-pink-900 via-pink-700 to-purple-800 text-white p-3.5 rounded-xl mb-3">
        <p className="text-[11.5px] leading-relaxed font-serif italic opacity-90">
          "You send double texts about 40% of the time — usually after painfully generic openers like 'hey' or 'what's up.' There's a sense of eagerness. Your response time is suspiciously fast, like you never miss a notification."
        </p>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-2 gap-2 mb-3">
        {[
          { value: '127', label: 'Total Messages', from: 'from-pink-400', to: 'to-rose-500' },
          { value: '😂', label: 'Top Emoji', from: 'from-amber-400', to: 'to-orange-500' },
          { value: '47', label: 'Longest Chat', from: 'from-violet-400', to: 'to-purple-600' },
          { value: '3', label: 'Times Aired', from: 'from-red-400', to: 'to-orange-500' },
        ].map(({ value, label, from, to }) => (
          <div key={label} className={`bg-gradient-to-br ${from} ${to} p-3 rounded-xl text-center`}>
            <div className="text-base font-black text-white leading-none mb-1">{value}</div>
            <div className="text-[9px] text-white/80 font-medium">{label}</div>
          </div>
        ))}
      </div>

      {/* Response times */}
      <div className="bg-gray-50 border border-gray-100 p-3 rounded-xl">
        <div className="flex items-center gap-1.5 mb-2.5">
          <Clock className="w-3 h-3 text-gray-400" />
          <span className="text-[10px] font-bold text-gray-700">Response Times</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div className="text-center">
            <div className="text-sm font-black text-blue-600">2.3 min</div>
            <div className="text-[9px] text-gray-500 mt-0.5">You</div>
            <div className="mt-1.5 h-1 rounded-full bg-blue-200">
              <div className="h-full w-2/5 bg-blue-500 rounded-full" />
            </div>
          </div>
          <div className="text-center">
            <div className="text-sm font-black text-emerald-600">5.7 min</div>
            <div className="text-[9px] text-gray-500 mt-0.5">Others</div>
            <div className="mt-1.5 h-1 rounded-full bg-emerald-200">
              <div className="h-full w-full bg-emerald-500 rounded-full" />
            </div>
          </div>
        </div>
        <p className="text-[9px] text-gray-400 text-center mt-2 italic">You reply 2.4× faster than your matches</p>
      </div>

    </div>
  );
}

export default ExamplePageOne;
